import React from "react";

export default function VentanaPerfil({ datosPerfil, onClose, isOpen }) {
  return (
    <>
      {/* Ventana de perfil 
      <div
        data-figma-id="2585:14918"
        className={`ventana-perfil ${isOpen ? "" : "closed"}`}
      >
        <div data-figma-id="810:15698" class="foto-ventana-perfil">
          <p data-figma-id="810:15699" class="perfil-icono-texto-foto">
            {datosPerfil.iniciales}
          </p>
        </div>
        <div data-figma-id="2585:14855" class="ventana-perfil-contenido">
          <div data-figma-id="2585:14856" class="ventana-perfil-titulos">
            <p data-figma-id="2585:14857" class="ventana-perfil-titulo-1">
              {datosPerfil.nombre_completo}
            </p>
            <p data-figma-id="2585:14858" class="ventana-perfil-titulo-2">
              ID: {datosPerfil.id_empleado}
            </p>
          </div>
          <div data-figma-id="2585:14860" class="ventana-perfil-info">
            <div data-figma-id="2585:14861" class="info-correo">
              <p data-figma-id="2585:14862" class="info-correo-texto-1">
                Correo:
              </p>
              <p data-figma-id="2585:14863" class="info-correo-texto-2">
                {datosPerfil.correo}
              </p>
            </div>
            <div data-figma-id="2585:14864" class="info-telefono">
              <p data-figma-id="2585:14865" class="info-telefono-1">
                Teléfono:
              </p>
              <p data-figma-id="2585:14866" class="info-telefono-2">
                {datosPerfil.telefono}
              </p>
            </div>
            <div data-figma-id="2585:14867" class="info-usuario">
              <p data-figma-id="2585:14868" class="info-usuario-1">
                Usuario:
              </p>
              <p data-figma-id="2585:14869" class="info-usuario-2">
                {datosPerfil.usuario}
              </p>
            </div>
            <div data-figma-id="2585:14870" class="info-contrasea">
              <p data-figma-id="2585:14871" class="info-contrasea-texto">
                Contraseña:
              </p>
              <div data-figma-id="2585:14872" class="contrasea-perfil-texto">
                <i class="fi fi-rr-lock cerrar-2"></i>
                <div
                  data-figma-id="2585:14874"
                  class="contrasea-puntos-ventana-perfil"
                >
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                  <div
                    data-figma-id="2585:14874"
                    class="contrasea-puntos-ventana-perfil"
                  >
                    <div data-figma-id="2585:14902" class="circle-small-1-10">
                      <i class="fi fi-ss-bullet password-icono"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <i
          class="fi fi-rs-circle-xmark cross-circle-cerrar-ventana-perfil"
          onClick={onClose}
        ></i>
      </div>
*/}

      <div
        data-figma-id="2774:14003"
        className={`ventana-perfil-2 ${isOpen ? "" : "closed"}`}
      >
        <div data-figma-id="2768:14076" class="frame-290238">
          <i
            class="fi fi-rs-circle-xmark cross-circle-cerrar-ventana-perfil-2"
            onClick={onClose}
          ></i>
        </div>
        <div data-figma-id="2768:14078" class="frame-290239">
          <div data-figma-id="2768:14079" class="foto-ventana-perfil-2">
            <p data-figma-id="2768:14080" class="sm">
              {datosPerfil.iniciales}
            </p>
          </div>
          <div data-figma-id="2768:14081" class="ventana-perfil-contenido-2">
            <div data-figma-id="2768:14082" class="ventana-perfil-titulos-2">
              <p data-figma-id="2768:14083" class="ventana-perfil-titulo-1-2">
                {datosPerfil.nombre_completo}
              </p>
              <p data-figma-id="2768:14084" class="ventana-perfil-titulo-2-2">
                ID: {datosPerfil.id_empleado}
              </p>
            </div>
            <div data-figma-id="2768:14086" class="ventana-perfil-info-2">
              <div data-figma-id="2768:14087" class="info-correo-2">
                <i class="fi fi-rr-envelope envelope-4-1"></i>
                <p data-figma-id="2768:14089" class="info-correo-texto-2-2">
                  {datosPerfil.correo}
                </p>
              </div>
              <div data-figma-id="2768:14090" class="info-telefono-2">
                <i class="fi fi-rr-mobile-button mobile-button-1"></i>
                <p data-figma-id="2768:14092" class="info-telefono-2-2">
                  {datosPerfil.telefono}
                </p>
              </div>
              <div data-figma-id="2768:14093" class="info-usuario-2">
                <i class="fi fi-rr-user user-2-1"></i>
                <p data-figma-id="2768:14095" class="info-usuario-2-2">
                  {datosPerfil.usuario}
                </p>
              </div>
              <div data-figma-id="2768:14096" class="contrasea-perfil-texto-2">
                <i class="fi fi-rr-lock cerrar-2"></i>
                <div
                  data-figma-id="2768:14098"
                  class="contrasea-puntos-ventana-perfil-2"
                >
                  <div data-figma-id="2768:14138" class="circle-small-1-10-2">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14140" class="circle-small-1-11">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14142" class="circle-small-1-12">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14144" class="circle-small-1-13">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14146" class="circle-small-1-14">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14148" class="circle-small-1-15">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14150" class="circle-small-1-16">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                  <div data-figma-id="2768:14152" class="circle-small-1-17">
                    <i class="fi fi-ss-bullet "></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
